<script type="text/jsx">
import { mapGetters } from "vuex";
import buyTrial from './buy-trial';
import addTrial from './add-trial';
import BuyNow from './buy-now';
import BuyNowTrial from './buy-now-trial'
import planPropsMixin from '@/plans/mx/plan-props';
import { planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';

export default {
  mixins: [planPropsMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
  },
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};

    if (this.$context.is.buyTrial) return <buyTrial {...context} />;
    if (this.$context.is.add2trial) return <addTrial {...context} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) {
      if (plansof(this.getSelectedPlans).type(planTypes.ZOOM_SCHEDULER).get(0).isOnlineFreeTrial) {
        return <BuyNowTrial {...context} />
      }
    }
    return <BuyNow {...context} />;
  },
};
</script>